import EntitySuggestionPopups from './EntitySuggestionPopups';

export const EntitySuggestionPopupsMixin = EntitySuggestionPopups;
